import { useEffect, useState } from "react";
import { HandCoins, Heart, Sparkles, GraduationCap, Stethoscope, Leaf, Info, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { waLink } from "@/pages/public/ContactPage";

const CAUSES = [
  { icon: Heart, title: "Gau Seva", desc: "Feed, shelter and care for cows at our goshala." },
  { icon: HandCoins, title: "Annadan Seva", desc: "Provide meals to the poor and needy." },
  { icon: GraduationCap, title: "Education Support", desc: "Support yoga and skill education for youth." },
  { icon: Stethoscope, title: "Health Welfare", desc: "Fund health and medical camps." },
  { icon: Sparkles, title: "Yoga & Wellness", desc: "Sustain yoga programs and camps." },
  { icon: Leaf, title: "Environment & Social Welfare", desc: "Tree plantation, conservation drives and community welfare." },
];

export default function DonatePage() {
  const { t } = useLang();
  const [wa, setWa] = useState("");
  useEffect(() => { api.get("/public/content/contact").then((r) => setWa(waLink(r.data?.whatsapp))).catch(() => {}); }, []);

  return (
    <div data-testid="public-donate-page">
      <section className="bg-[#0E2916] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C59B27] font-mono">{t("Support Us")}</p>
          <h1 className="font-display text-4xl lg:text-5xl font-semibold mt-2">{t("Donation & Seva")}</h1>
          <p className="text-white/70 mt-3 max-w-xl">{t("Your contribution sustains yoga, Gau Seva, Annadan and welfare across Kutch.")}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h2 className="font-display text-3xl font-semibold text-[#194324]">{t("Choose a cause")}</h2>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CAUSES.map((c) => (
            <div key={c.title} className="bg-white rounded-xl border border-[#E2DAD0] p-6 hover:border-[#C59B27] hover:shadow-md transition-all" data-testid={`donate-cause-${c.title}`}>
              <div className="h-11 w-11 rounded-lg bg-[#F9F3E3] flex items-center justify-center mb-4"><c.icon className="h-5 w-5 text-[#C59B27]" /></div>
              <h3 className="font-display text-xl font-semibold text-[#194324]">{t(c.title)}</h3>
              <p className="text-sm text-[#3A4E41] mt-2">{t(c.desc)}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#F9F3E3] border border-[#E5D298] rounded-2xl p-6 sm:p-8 flex items-start gap-4" data-testid="donate-payment-notice">
          <Info className="h-6 w-6 text-[#A8811A] shrink-0 mt-0.5" />
          <div>
            <h3 className="font-display text-xl font-semibold text-[#194324]">{t("Online payment coming soon")}</h3>
            <p className="text-[#3A4E41] mt-2 leading-relaxed">{t("Online donations are not available yet. To donate, please contact the Trust by phone, WhatsApp or the contact form.")}</p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link to="/contact"><Button className="rounded-full bg-[#194324] hover:bg-[#2D623A] text-white" data-testid="donate-contact-button">{t("Contact for Donation")}</Button></Link>
              {wa && <a href={wa} target="_blank" rel="noopener noreferrer"><Button variant="outline" className="rounded-full border-[#194324]/30 text-[#194324]" data-testid="donate-whatsapp-button"><MessageCircle className="h-4 w-4 mr-2" />{t("WhatsApp for Donation")}</Button></a>}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
